import { InjectionToken } from "@angular/core";

export const IS_MOBILE = new InjectionToken<boolean>('isMobile');
export const isMobile = document.documentElement.classList.contains('mobile');
